<header class="top-navbar" *ngIf="user">
  <div class="d-flex align-items-center justify-content-between w-100">
    <button
      type="button"
      class="btn btn-light mobile-menu-button d-lg-none"
      (click)="toggleSidebar()"
      aria-label="Open navigation menu"
    >
      <i class="bi bi-list"></i>
    </button>
    <div
      class="company-switcher d-none d-md-block"
      *ngIf="user.companies && user.companies.length === 1"
    >
      <div
        class="btn btn-light d-flex align-items-center bg-white border rounded-pill shadow-sm py-2 px-3"
      >
        <i class="bi bi-building me-2 text-primary"></i>
        <span class="fw-semibold small me-1">{{ user.companies[0].name }}</span>
      </div>
    </div>
    <div
      class="dropdown company-switcher d-none d-md-block"
      *ngIf="user.companies && user.companies.length > 1"
    >
      <button
        class="btn btn-light dropdown-toggle d-flex align-items-center bg-white border rounded-pill shadow-sm py-2 px-3"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i class="bi bi-building me-2 text-primary"></i>
        <span class="fw-semibold small me-1">{{ currentCompany?.name }}</span>
      </button>
      <ul class="dropdown-menu border-0 shadow-lg mt-2 rounded-3">
        <li><h6 class="dropdown-header">Switch Company</h6></li>
        <li *ngFor="let company of user.companies">
          <a
            class="dropdown-item py-2 d-flex align-items-center justify-content-between"
            href="javascript:void(0)"
            (click)="switchCompany(company.id)"
            ><span
              ><i class="bi bi-building-check me-2 text-primary"></i>
              {{ company.name }}</span
            ><span
              *ngIf="company.id === user.currentCompanyId"
              class="badge bg-success-subtle text-success-emphasis rounded-pill"
              >Current</span
            ><span
              *ngIf="company.id !== user.currentCompanyId"
              class="badge bg-secondary-subtle text-secondary-emphasis rounded-pill"
              >Switch</span
            ></a
          >
        </li>
      </ul>
    </div>

    <div class="d-flex align-items-center flex-wrap gap-2 gap-sm-3">
      <div
        class="notification-bell"
        [class.notification-bell-active]="isNotificationBlinking"
        routerLink="/notifications"
      >
        <span class="notification-pulse" *ngIf="isNotificationBlinking"></span>
        <i class="bi bi-bell fs-5 text-muted"></i>
        <span class="notification-badge" *ngIf="notificationCount > 0">{{
          notificationCount
        }}</span>
      </div>

      <div class="dropdown company-switcher">
        <button
          class="btn btn-light dropdown-toggle d-flex align-items-center bg-white border rounded-pill shadow-sm py-2 px-3"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <div class="text-end me-2 d-none d-sm-block">
            <span class="d-block fw-semibold small"
              >{{ user.firstName }} {{ user.lastName }}</span
            >
          </div>
          <img
            [src]="
              makeImageURL(user.profileImage) ||
              'https://ui-avatars.com/api/?name=' +
                (user.firstName || '') +
                ' ' +
                (user.lastName || '') +
                '&background=4f46e5&color=fff'
            "
            class="rounded-circle shadow-sm"
            width="30"
            height="30"
          />
        </button>
        <ul
          class="dropdown-menu dropdown-menu-end border-0 shadow-lg mt-2 py-2 rounded-3"
          style="min-width: 200px"
        >
          <li class="px-3 py-2 border-bottom mb-2">
            <span class="d-block fw-bold text-dark"
              >{{ user.firstName }} {{ user.lastName }}</span
            >
            <span class="small text-muted">{{ user.email }}</span>
          </li>
          <li>
            <a class="dropdown-item py-2" routerLink="/profile"
              ><i class="bi bi-person me-2"></i> My Profile</a
            >
          </li>
          <li>
            <a class="dropdown-item py-2" href="#"
              ><i class="bi bi-gear me-2"></i> Settings</a
            >
          </li>
          <li><hr class="dropdown-divider" /></li>
          <li *ngIf="isImpersonating">
            <a
              class="dropdown-item py-2 text-primary"
              href="javascript:void(0)"
              (click)="switchBackToAdmin()"
              ><i class="bi bi-arrow-return-left me-2"></i> Back to me</a
            >
          </li>
          <li>
            <a
              class="dropdown-item py-2 text-danger"
              href="javascript:void(0)"
              (click)="logout()"
              ><i class="bi bi-box-arrow-right me-2"></i> Sign Out</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
